import 'ag-grid-enterprise';
import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';

class AgGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gridOptions: props.gridOptions,
            rowData: props.rowData,
            columnDefs: props.columnDefs
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            rowData: nextProps.rowData,
            columnDefs: nextProps.columnDefs
        });
    }

    render() {
        return (
            <div id={this.props.gridID ? this.props.gridID : "mygrid"} style={{ width: '100%' }} className="col-md-12 ag-fresh">
                <div
                    className="ag-theme-balham grid-container"
                    style={{
                        font: '.8em Segoe UI, sans-serif',
                        margin: '15px'
                    }}
                >
                    <AgGridReact
                        gridOptions={this.state.gridOptions}
                        rowData={this.state.rowData}
                        columnDefs={this.state.columnDefs}
                        onCellValueChanged={this.props.onCellValueChanged}
                        onSelectionChanged={this.props.onSelectionChanged}
                        onFirstDataRendered={this.props.onFirstDataRendered}
                        onCellClicked={this.props.onCellClicked}
                        onRowDataChanged={this.props.onRowDataChanged}
                        onPasteStart={this.props.onPasteStart}
                        onPasteEnd={this.props.onPasteEnd}
                        onCellEditingStopped={this.props.onCellEditingStopped}
                        getContextMenuItems={this.props.getContextMenuItems}
                        suppressContextMenu={this.props.suppressContextMenu}
                        domLayout={this?.props?.domLayout ?? undefined}

                        suppressClickEdit={this.props.suppressClickEdit}
                        enableRangeSelection={this?.props?.enableRangeSelection ?? undefined}
                        rowSelection={this?.props?.rowSelection ?? undefined}
                        suppressCopySingleCellRanges={this?.props?.suppressCopySingleCellRanges ?? undefined}
                        processCellFromClipboard={this.props.processCellFromClipboard}
                    ></AgGridReact>
                </div>
            </div>
        );
    }
}

export default AgGrid;
